import styled from '@emotion/styled';

import {
  animation,
  boxShadow,
  breakpoints,
  colors,
  fontWeight,
} from '@datacamp/waffles-tokens';

export const A = styled.a`
  color: ${colors.grey};
  display: block;
  font-weight: ${fontWeight.regular};
  margin: 16px;
  transition: transform ${animation.transition};

  h3 {
    margin-top: 12px;
    transition: color ${animation.transition};
  }

  .block {
    transition: box-shadow ${animation.transition};
    width: 100%;
  }

  p:last-of-type {
    margin-bottom: 0;
  }

  &:active,
  &:focus,
  &:hover {
    border-color: transparent;
    color: ${colors.grey};
    transform: translateY(-4px);

    h3 {
      color: ${colors.primary};
    }

    .block {
      box-shadow: ${boxShadow.lg};
    }
  }

  @media screen and (min-width: ${breakpoints.md}) {
    h3 {
      min-height: 90px; /* 30px line-height * 3 */
    }
  }
`;

export const Child = styled.div``;

export const Flex = styled.div`
  @media screen and (min-width: ${breakpoints.md}) {
    align-items: center;
    display: flex;
  }
`;
